/*
 本文件用于定义与API接口服务的代码
 只允许导出接口方法，不允许导出其它非接口方法的功能
 */
import * as httpAgent from 'utils/http'

const url = "/popadmin/admin"
/**
 * 获取用户信息
 *
 * @export
 * @returns
 */
export function getUserInfo() {
  return httpAgent.GET('/loginUserInfo')
}


/**
 * 检查店铺资质是否即将半年过期
 */
export function checkBusinessQualificationExpire(){
  return httpAgent.GET(`/popadmin/admin/supplierEnter/storeQualification/checkBusinessQualificationExpire`)
}

/**
 * 插入资质检查日志记录
 */
export function insertCheckLog(action){
  return httpAgent.GET(`/popadmin/admin/supplierEnter/storeQualification/insertCheckLog/${action}`)
}

/**
 * 获取资质过期时间
 */
export function getBusinessQualificationExpire(){
  return httpAgent.GET(`/popadmin/admin/supplierEnter/storeQualification/getBusinessQualificationExpire`)
}

/**
 * 获取菜单
 *
 * @export
 * @returns
 */
export function getMenus() {
  return httpAgent.GET('/popadmin/admin/menuAll')
}
/**
 * 未登录跳转
 *
 * @export
 * @returns
 */
export function getToUrl() {
  return httpAgent.GET('/popadmin/admin/redirect/login')
}
/**
 * 获取仓库列表
 *
 * @export
 * @returns
 */
export function getHouseList(data, options) {
  return httpAgent.POST('/popadmin/admin/warehouse/getMyWarehouseList', data, options)
}

/**
 * 修改密码
 *
 * @export
 * @returns
 */
export function postModifyPossword(data, options) {
  return httpAgent.POST('/popadmin/admin/user/changePassword', data, options)
}

/**
 * 退出
 *
 * @export
 * @returns
 */
export function postOut(data, options) {
  return httpAgent.POST('/popadmin/admin/user/logout', data, options)
}

/**
 * 获取未读公告
 *
 * @export
 * @returns
 */
export function getAnnouncementUnread() {
  return httpAgent.GET('/popadmin/admin/buyerHomePage/getUnReadAnnouncement')
}

/**
 * 设置单次弹窗公告为已读
 *
 * @export
 * @returns
 */
export function setUnreadRead(data, options) {
  return httpAgent.POST('/popadmin/admin/buyerHomePage/setUnreadRead', data, options)
}

/**
 * 3.获取一级类目
 *
 * @export
 * @returns
 */
export function findFirstCateg() {
  return httpAgent.GET(`${url}/supplierEnter/enter/findFirstCateg`)
}

/**
 * 新手任务查询
 *
 * @export
 * @returns
 */
export function checkNewTaskStatus(params, options) {
  return httpAgent.GET(`/popadmin/admin/supplierEnter/newTask/checkNewTaskStatus`, params, options)
}

/**
 * @method 
 * @param {type} 参数名 参数说明
 * @return {type} 返回值
 * @desc 获取站内信未读信息
 */
export function getUnReadInternalMessage(params) {
    return httpAgent.GET(`/popadmin/admin/storeViolation/insideMessage/getUnreadMessage`,params)
}

/**
 * @method 
 * @param {type} 参数名 参数说明
 * @return {type} 返回值
 * @desc 获取站内信未读信息数量
 */
export function getUnReadInternalMessageNum(params) {
    return httpAgent.GET(`/popadmin/admin/storeViolation/insideMessage/getUnreadMessageNum`,params)
}

/**
 * @method 
 * @param {type} 参数名 参数说明
 * @return {type} 返回值
 * @desc  标记单个站内信已读
 */

export function readSignleMessage(params) {
    return httpAgent.GET(`/popadmin/admin/storeViolation/insideMessage/readSignleMessage`, params);
}



export function getQualityGoodsNum(){
  return httpAgent.GET(`/popadmin/admin/popGoodsQualification/getQualityGoodsNum`)
}
